import { render } from "./CommunityView.vue?vue&type=template&id=a930f366"
import script from "./CommunityView.vue?vue&type=script&lang=js"
export * from "./CommunityView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__